'use client'
import { Grid, Box } from '@achieve/ascend'
import { CardValueProp } from 'components/Cards'
import classNames from 'classnames'
import { useViewportSmallerThan } from 'utils/viewport'
import { BREAKPOINTS } from 'constants/viewport'
import { SITE_ENVIRONMENTS } from 'constants/websites'
import {} from 'react'

export default function ValuePropsBody({ grid, config, idContent }) {
  const siteEnv = process.env.NEXT_PUBLIC_SITE_ENVIRONMENT || 'achieve'
  const isMobile = useViewportSmallerThan(BREAKPOINTS.lg)

  const getGridItem = (id, item, dividerOnMobile) => {
    return (
      <Grid
        size={{ xs: 12, md: 12, lg: 3.5 }}
        data-item-id={id}
        className={classNames(
          (id + 1) % config?.itemsByrow == 0 || !config?.dividerToggle
            ? ''
            : 'border-none lg:border-r lg:border-solid lg:border-y-0 lg:border-l-0 lg:border-[#42546b] lg:pr-4',
          id + 1 > config?.itemsByrow && 'pt-0 lg:pt-[48px]',
          { '[&:last-child>div>div]:mb-0': siteEnv === SITE_ENVIRONMENTS.FDR }
        )}
        key={`card-${id}`}
      >
        <Box data-testid="value-prop-2-grid-card-item" className={'lg:max-w-[305px] lg:m-auto'}>
          <CardValueProp
            cardStyle={config?.cardStyle}
            content={item}
            isMobile={isMobile}
            breakline={config?.breakline}
            dividerOnMobile={dividerOnMobile}
            pos={id}
            gridConfig={config?.gridConfig}
            className={config?.jsonContent?.className}
          />
        </Box>
      </Grid>
    )
  }
  const gridItems = (dividerOnMobile = false, max) => {
    return (
      <>
        {grid?.gridItemsCollection?.items?.map((item, idx) => {
          if (idx >= max && max !== 0) return null
          return getGridItem(idx, item, dividerOnMobile)
        })}
      </>
    )
  }

  return (
    <Grid
      item
      sm={10}
      md={8}
      lg={12}
      data-testid={`value-prop-2-grid-card-container-${idContent}`}
      className={classNames(
        isMobile
          ? 'flex flex-col justify-between items-stretch gap-4'
          : 'flex flex-row justify-between items-stretch gap-4'
      )}
      data-variant={config?.jsonContent?.variant || 'standard'}
    >
      {gridItems(config?.dividerOnMobile, isMobile ? config?.maxMobileItems : 0)}
    </Grid>
  )
}
